import { useEffect, useState } from "react";
import axios from "axios";
import { baseurladdress } from "../baseurl";

function BirthdayPopup() {
    const accesstoken = localStorage.getItem("token");
    const loggedInStaffId = localStorage.getItem("staffid");

    const [birthdayData, setBirthdayData] = useState(null);
    const [visible, setVisible] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (!accesstoken) return;

        const today = new Date();
        const todayMonth = today.getMonth() + 1;
        const todayDay = today.getDate();

        axios
            .get(baseurladdress + "findallstaff", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const staffList = res.data.response || [];
                const birthdayStaff = [];

                staffList.forEach((staff) => {
                    if (!staff.staff_dob) return;

                    let dobDate = null;

                    if (staff.staff_dob.includes("-")) {
                        dobDate = new Date(staff.staff_dob);
                    } else if (staff.staff_dob.includes("/")) {
                        const parts = staff.staff_dob.split("/");
                        dobDate = new Date(parts[2], parts[1] - 1, parts[0]);
                    }

                    if (dobDate && !isNaN(dobDate.getTime())) {
                        const dobMonth = dobDate.getMonth() + 1;
                        const dobDay = dobDate.getDate();

                        if (dobMonth === todayMonth && dobDay === todayDay) {
                            birthdayStaff.push({
                                staff_id: staff.staff_id,
                                staff_name: staff.staff_name,
                            });
                        }
                    }
                });

                if (birthdayStaff.length > 0) {
                    const myBirthday = birthdayStaff.find(
                        (s) => String(s.staff_id) === String(loggedInStaffId)
                    );
                    const others = birthdayStaff.filter(
                        (s) => String(s.staff_id) !== String(loggedInStaffId)
                    );

                    setBirthdayData({
                        isMine: !!myBirthday,
                        myName: myBirthday ? myBirthday.staff_name : "",
                        otherNames: others.map((s) => s.staff_name).join(", "),
                        hasOthers: others.length > 0,
                        names: birthdayStaff.map((s) => s.staff_name).join(", "),
                    });
                    setVisible(true);
                }
            })
            .catch((err) => {
                console.log("Birthday check error:", err);
            });
    }, [accesstoken, loggedInStaffId]);

    const handleDismiss = () => {
        setVisible(false);
        setDismissed(true);
    };

    const handleReopen = () => {
        setVisible(true);
        setDismissed(false);
    };

    // If no birthday data at all, render nothing
    if (!birthdayData) return null;

    const isMine = birthdayData.isMine;

    return (
        <>
            {/* ── Birthday Card ── */}
            {visible && (
                <div
                    style={{
                        position: "fixed",
                        top: "70px",
                        right: "20px",
                        zIndex: 9999,
                        maxWidth: "320px",
                        minWidth: "260px",
                        background: isMine
                            ? "linear-gradient(135deg, #fce4ec, #f8bbd0)"
                            : "linear-gradient(135deg, #e3f2fd, #bbdefb)",
                        borderRadius: "16px",
                       padding: "16px 20px",
overflow: "hidden",
position: "fixed",
                        boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                        border: isMine
                            ? "2px solid #f48fb1"
                            : "2px solid #90caf9",
                        animation: "slideInRight 0.5s ease-out",
                        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    }}
                >
                    <style>{`
@keyframes slideInRight {
    from {
        transform: translateX(120%);
        opacity:0;
    }
    to {
        transform: translateX(0);
        opacity:1;
    }
}

@keyframes bounce {
    0%,100%{
        transform:scale(1);
    }
    50%{
        transform:scale(1.15);
    }
}

@keyframes confettiFall{
    0%{
        transform:translateY(-30px) rotate(0deg);
        opacity:1;
    }

    100%{
        transform:translateY(330px) rotate(720deg);
        opacity:0;
    }
}

.confetti{
    position:absolute;
    top:-20px;
    width:8px;
    height:16px;
    border-radius:3px;
    animation:confettiFall linear infinite;
}

.banner{
    text-align:center;
    font-size:17px;
    font-weight:bold;
    color:#e91e63;
    margin-bottom:8px;
}
`}</style>

                    {/* Close button */}
                    <button
                        onClick={handleDismiss}
                        style={{
                            position: "absolute",
                            top: "6px",
                            right: "10px",
                            background: "transparent",
                            border: "none",
                            fontSize: "18px",
                            cursor: "pointer",
                            color: isMine ? "#c2185b" : "#1565c0",
                            lineHeight: 1,
                            padding: "0 4px",
                        }}
                        title="Close"
                    >
                        ✕
                    </button>

{/* Party Papers */}

{[...Array(40)].map((_, i) => (
    <span
        key={i}
        className="confetti"
        style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${2 + Math.random() * 2}s`,
            animationDelay: `${Math.random() * 3}s`,
            background: [
                "#ff1744",
                "#ffeb3b",
                "#00e676",
                "#2979ff",
                "#ff9800",
                "#d500f9",
                "#00bcd4",
                "#ff4081"
            ][i % 8]
        }}
    />
))}
                    {/* Content */}
                    <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                        <div
                            style={{
                                fontSize: "36px",
                                lineHeight: 1,
                                flexShrink: 0,
                            }}
                        >
                            {isMine ? "🎂" : "🎈"}
                        </div>
                        <div style={{ flex: 1 }}>
                            <div
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    color: isMine ? "#c2185b" : "#1565c0",
                                    marginBottom: "4px",
                                }}
                            >
                                {isMine
                                    ? `Happy Birthday ${birthdayData.myName}! 🎉`
                                    : `Birthday Today! 🎉`}
                            </div>
                            <div
                                style={{
                                    fontSize: "13px",
                                    color: isMine ? "#880e4f" : "#0d47a1",
                                    lineHeight: "1.4",
                                }}
                            >
                                {isMine && birthdayData.hasOthers
                                    ? `Also ${birthdayData.otherNames} share${birthdayData.otherNames.includes(",") ? "" : "s"} this birthday with you! 🎉`
                                    : isMine
                                    ? "Wishing you a fantastic day filled with joy and happiness!"
                                    : `It's ${birthdayData.names}'s birthday today. Let's wish them!`}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Reopen Button (shows after dismiss) ── */}
            {dismissed && (
                <div
                    onClick={handleReopen}
                    style={{
                        position: "fixed",
                        top: "70px",
                        right: "20px",
                        zIndex: 9999,
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        background: isMine
                            ? "linear-gradient(135deg, #f48fb1, #ec407a)"
                            : "linear-gradient(135deg, #90caf9, #42a5f5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
                        animation: "bounce 2s infinite",
                        fontSize: "24px",
                        transition: "transform 0.2s",
                    }}
                    title="Show birthday message"
                >
                    {isMine ? "🎂" : "🎈"}
                </div>
            )}
        </>
    );
}

export default BirthdayPopup;